import React, {useState} from "react"
import { useHistory } from "react-router-dom"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Drawer from "@material-ui/core/Drawer"
import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"
import List from "@material-ui/core/List"
import Divider from "@material-ui/core/Divider"
import IconButton from "@material-ui/core/IconButton"
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import { Typography, Hidden } from "@material-ui/core"
import Collapse from "@material-ui/core/Collapse"
import Footer from "./Footer"

const drawerWidth = 300

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
    background: "#003366",
    color: "#FFFFFF",
  },
  avatar: {
    marginRight: theme.spacing(1),
  },
  appSelection: {
    margin: "0px 20px 10px 20px",
    display: "flex",
    flexDirection: "column",
  },
  nested: {
    paddingLeft: theme.spacing(4),
    backgroundColor: "#3b536b",
    color: "#FFFFFF",
    "&:hover, &.Mui-selected": { color: "#3b536b" },
  },
}))

const LeftNav = ({ handleHideLeftNav, showLeftNav, route, user }) => {
  const classes = useStyles()
  const theme = useTheme()
  const [isOpenClickAndCollect, setIsOpenClickAndCollect] = useState( false )
  const [isOpenB2BWalkin, setIsOpenB2BWalkin] = useState( false )
  const [isOpenB2BCorporate, setIsOpenB2BCorporate] = useState( false )
  
  const history = useHistory()
  const handleDrawerClose = () => handleHideLeftNav()

  const openClickAndCollect = () => {
    setIsOpenClickAndCollect(!isOpenClickAndCollect)
  }


  const menuItems = [
    { label: "Home", url: "/" },
    {
      label: "Call-And-Collect",
      handler: openClickAndCollect,
      open: isOpenClickAndCollect,
      children: [
        { label: "Search Sku", url:"/search-sku"},
        { label: "Search Orders", url:"/search-cc"},
        { label: "Active Orders", url: "/call-and-collect" },
        // { label: "Pick Orders", url: "/call-collect-picking" },
        { label: "Pickup", url: "/pickup-cc" },
        { label: "Survey", url: "/survey-cc" },
       
      ],
    },
    {
      label: "B2B Walk-in Transactions",
      handler: ()=> setIsOpenB2BWalkin( !isOpenB2BWalkin ),
      open: isOpenB2BWalkin,
      children: [
        { label: "Search Transactions", url:"/search-walkin"}
      ],
    },
    {
      label: "B2B Corp Accts Transactions",
      handler: ()=> setIsOpenB2BCorporate( !isOpenB2BCorporate ),
      open: isOpenB2BCorporate,
      children: [
        { label: "Search Corp Transactions", url:"/search-corporate"}
      ],
    },
    { label: "Reports", url: "/onDemandReports" },
    // {
    //   label: "B2B",
    //   handler: openB2B,
    //   open: isOpenB2b,
    //   children: [
    //     { label: "Orders", url: "/b2b-orders" },
    //     // { label: "Upcoming Orders", url: "/b2b-upcoming" }
    //   ],
    // },
  ]

  if( user.branch ){
    menuItems.forEach( menuItem => {
      if( menuItem.label === "Call-And-Collect" ){
        menuItem.children.unshift( { label: "Upload Orders", url:"/upload-call-order"} )
        menuItem.children.unshift( { label: "Create Order", url:"/create-call-order"} )
      }

      if( menuItem.label === "B2B Walk-in Transactions" ){
        menuItem.children.unshift( { label: "Create Walk-in Transaction", url:"/b2b-walkin"} )
      }

      if( menuItem.label === "B2B Corp Accts Transactions" ){
        menuItem.children.unshift( { label: "Create Corp Accts Transaction", url:"/b2b-corporate"} )
      }
    })

    menuItems.push(
      { label: "CNC & Foot Traffic", url: "/foot-traffic" }
    )

    menuItems.push(
      { label: "My Branch", url: "/my-branch" }
    )
  }else{
      menuItems.forEach( menuItem => {
        if( menuItem.label === "Call-And-Collect" ){
          menuItem.children.push( { label: "Transactions", url: "/transactions/cc" } )
          menuItem.children.push( { label: "Payment Verification", url:"/call-collect-verification"} )
        }
      })    
  }

  return (
    <Drawer
      className={classes.drawer}
      variant="temporary"
      open={showLeftNav}
      onClose={handleDrawerClose}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.drawerHeader}>
        <Typography variant="h6" style={{ marginRight: 20 }}>
          Order Management
        </Typography>
        <IconButton onClick={handleDrawerClose}>
          {theme.direction === "ltr" ? (
            <ChevronLeftIcon style={{ color: "#FFFFFF" }} />
          ) : (
            <ChevronRightIcon style={{ color: "#FFFFFF" }} />
          )}
        </IconButton>
      </div>
      <Divider />
      <List>
        {menuItems.map((menuItem, i) => (
          <span key={i}>
            {menuItem.children ? (
              <>
                <ListItem button onClick={menuItem.handler}>
                  <ListItemText primary={menuItem.label} />
                  {menuItem.open ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={menuItem.open} timeout="auto">
                  {menuItem.children.map((child, indx) => (
                    <List component="div" disablePadding key={indx}>
                      <ListItem
                        selected={history.location.pathname.includes(child.url)}
                        className={classes.nested}
                        button
                        onClick={() => {
                          route.history.push(child.url)
                          handleHideLeftNav()
                        }}
                      >
                        <ListItemText primary={child.label} />
                      </ListItem>
                    </List>
                  ))}
                </Collapse>
              </>
            ) : (
              <ListItem
                button
                onClick={() => {
                  route.history.push(menuItem.url)
                  handleHideLeftNav()
                }}
              >
                <ListItemText primary={menuItem.label} />
              </ListItem>
            )}
          </span>
        ))}
      </List>
      <Hidden smDown>
        <Footer />
      </Hidden>
    </Drawer>
  )
}

export default LeftNav
